'use client'
import React, { useEffect } from 'react'
import cl from 'clsx'
import styles from './styles.module.css'

const ModalContactForm = ({isOpen, onClose, children, type}) => {
    useEffect(() => {
        // Function to lock scroll
        const lockScroll = () => {
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        };

        // Function to unlock scroll
        const unlockScroll = () => {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        };

        // Lock or unlock scroll based on the modal state
        if (isOpen) {
            lockScroll();
        } else {
            unlockScroll();
        }

        // Cleanup function to ensure scroll is unlocked when component unmounts or modal closes
        return () => unlockScroll();
    }, [isOpen]); // Dependency on the 'isOpen' state

    if(!isOpen) return null

    return (
        <div id={'modal-contact-form'} className={styles.modal_contact_form}>
            <div className={cl(
                    styles.modal_contact_form__content,
                    type === "quiz" && styles.modal_contact_form__content_quiz,
                    type === "contact-form-main" && styles.modal_contact_form__content_contact_form_main
                )}>
                {/*<Image*/}
                {/*    src={close}*/}
                {/*    className={styles.modal_contact_form__close}*/}
                {/*    onClick={onClose}*/}
                {/*    alt={'close'}/>*/}
                    <div className={styles.modal_contact_form__close} onClick={onClose}>+</div>
                {children}
            </div>
        </div>
    )
}

export default ModalContactForm
